import { useQuery } from "@tanstack/react-query";
import { apiRequest } from "./api";

// get Token
import useAuthToken from "../../Hooks/useAuthToken";

export const useCreateSection = () => {
  const token = useAuthToken();

  const createSection = async (credentials) => {
    if (!credentials) {
      throw new Error("Please provide credentials");
    }
    return apiRequest("post", "/api/section", credentials, token);
  };

  return createSection;
};

export const useGetSection = () => {
  const token = useAuthToken();

  const getSection = async () => {
    if (!token) {
      throw new Error("Token is missing");
    }

    return apiRequest("get", "/api/section", null, token);
  };

  return getSection;
};

export const useGetCategoryById = (id) => {
  const token = useAuthToken();

  // Function to fetch category data
  const getCategoryById = async () => {
    if (!token) {
      throw new Error("Token is missing");
    }

    const response = await apiRequest(
      "get",
      `/api/category/${id}`,
      null,
      token
    );

    return response;
  };
  return useQuery({
    queryKey: ["single-category", id],
    queryFn: getCategoryById,
    enabled: !!id,
  });
};

export const useUpdateSection = (id) => {
  const token = useAuthToken();

  const updateSection = async (formData) => {
    if (!token) {
      throw new Error("Token is missing");
    }
    const response = await apiRequest(
      "patch",
      `/api/section/${id}`,
      formData,
      token
    );

    return response;
  };

  return updateSection;
};
